/* Date */
interface Date {
    toISOLocalString(): string;
}

/* .toISOString converts a date with a timezoneoffset to a Zulu time string (UTC)
   This function instead preserves the local time and the offset in alternative
   ISO8601 format: 2031-03-20T11:45:15-11:00 */
Date.prototype.toISOLocalString = function (this: Date): string {
    // @ts-ignore TS2322
    if (!this) return null;
    const timezoneOffsetInHours = Math.floor(-(this.getTimezoneOffset() / 60)); //UTC minus local time, whole hours only
    const timezoneOffsetMinutes = this.getTimezoneOffset() % 60;
    const sign = timezoneOffsetInHours >= 0 ? '+' : '-';
    const leadingZeroHours = Math.abs(timezoneOffsetInHours) < 10 ? '0' : '';
    const leadingZeroMinutes = Math.abs(timezoneOffsetMinutes) < 10 ? '0' : '';

    //It's a bit unfortunate that we need to construct a new Date instance
    //(we don't want _this_ Date instance to be modified)
    const correctedDate = new Date(
        this.getFullYear(),
        this.getMonth(),
        this.getDate(),
        this.getHours(),
        this.getMinutes(),
        this.getSeconds(),
        this.getMilliseconds()
    );
    correctedDate.setHours(this.getHours() + timezoneOffsetInHours);
    const iso = correctedDate.toISOString().replace('Z', '');

    return (
        iso +
        sign +
        leadingZeroHours +
        Math.abs(timezoneOffsetInHours).toString() +
        ':' +
        leadingZeroMinutes +
        Math.abs(timezoneOffsetMinutes).toString()
    );
};
